<template>
	<div
		class="g-block-divider-dashed g-block-divider-padding"
		:class="{
			'g-block-divider-dashed--edit': editable,
			'is-active': editable && active,
			'g-block-divider-dashed--h5': h5,
			'g-block-divider-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<span
			class="g-block-divider-dashed__line"
			:style="{ borderColor: themeColor }"
			aria-hidden="true"
		></span>
	</div>
</template>

<script>
	import { dividerMixin } from '../shared/dividerMixin.js';

	export default {
		name: 'GBlockDividerDashed',
		mixins: [dividerMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/dividerEditShell.less';

	.g-block-divider-dashed {
		.divider-block-edit-shell();
	}

	.g-block-divider-dashed__line {
		display: block;
		width: 100%;
		height: 0;
		border-top: 1px dashed;
	}

	.g-block-divider-dashed--h5 {
		.g-block-divider-dashed__line {
			border-top-width: 0.02rem;
		}
	}
</style>
